<template>
  <component :is="tag" class="ui-section" :class="sectionClass" :style="style">
    <div class="container">
      <slot />
    </div>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  as?: string
  semantic?: boolean
  bgImage?: string
  bgColor?: string
  noPadding?: boolean
  noBackground?: boolean
}>()

const tag = computed(() => {
  if (props.as) return props.as
  if (props.semantic === false) return 'div'
  return 'section'
})

const sectionClass = computed(() => {
  return {
    'ui-section--padded': !props.noPadding,
    'ui-section--background': !props.noBackground && !props.bgImage && !props.bgColor,
  }
})

const style = computed(() => {
  const styles: Record<string, string> = {}
  if (props.bgImage) {
    styles.backgroundImage = `url(${props.bgImage})`
    // styles.backgroundSize = 'cover'
    // styles.backgroundPosition = 'center'
  }
  if (props.bgColor) {
    styles.backgroundColor = props.bgColor
  }
  return styles
})
</script>

<style scoped lang="scss">
.ui-section--background {
  background: var(--background);
}
.ui-section {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 100%;
  flex-grow: 1;

  .container {
    z-index: 2;
    width: 100%;
    max-width: var(--max-container-width);
    height: 100%;
    margin-inline: auto;
    padding-inline: clamp(1rem, 5vw, 2rem);
  }
}
</style>
